import { render, staticRenderFns } from "./sign-affirm.vue?vue&type=template&id=5da09af0&scoped=true&"
import script from "./sign-affirm.vue?vue&type=script&lang=js&"
export * from "./sign-affirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da09af0",
  null
  
)

export default component.exports